import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09e1a05a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-kanban-card" }
const _hoisted_2 = {
  key: 0,
  class: "task__subtask-line"
}
const _hoisted_3 = {
  key: 1,
  class: "task__status-container"
}
const _hoisted_4 = { class: "task__status" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task__status-dot" }, null, -1))
const _hoisted_6 = { class: "task__status-text" }
const _hoisted_7 = { class: "task__header" }
const _hoisted_8 = { class: "task__taskid" }
const _hoisted_9 = { class: "task__title-wrapper" }
const _hoisted_10 = { class: "task__title" }
const _hoisted_11 = {
  key: 2,
  class: "task__controls"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task__popover-title" }, "Очередь", -1))
const _hoisted_13 = { class: "task__queue" }
const _hoisted_14 = {
  key: 3,
  class: "task__user"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task__popover-title" }, "Автор", -1))
const _hoisted_16 = { class: "task__popover-title" }
const _hoisted_17 = {
  key: 4,
  class: "task__performers"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task__popover-title" }, "Исполнитель", -1))
const _hoisted_19 = { class: "task__popover-title" }
const _hoisted_20 = {
  key: 5,
  class: "task__observers"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task__popover-title" }, "Наблюдатель", -1))
const _hoisted_22 = { class: "task__persons" }
const _hoisted_23 = { class: "task__popover-title" }
const _hoisted_24 = {
  key: 6,
  class: "task__priority"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task__popover-title" }, "Приоритет", -1))
const _hoisted_26 = { class: "task__priority-text" }
const _hoisted_27 = {
  key: 7,
  class: "task__difficulty"
}
const _hoisted_28 = { class: "task__priority-text" }
const _hoisted_29 = {
  key: 8,
  class: "task__deadline"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task__popover-title" }, "Дедлайн", -1))
const _hoisted_31 = {
  key: 9,
  class: "task__time-evaluation"
}
const _hoisted_32 = {
  key: 10,
  class: "task__time-evaluation"
}
const _hoisted_33 = {
  key: 11,
  class: "task__tags"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task__popover-title" }, "Тег", -1))
const _hoisted_35 = { class: "task__tags-wrapper" }
const _hoisted_36 = {
  key: 0,
  class: "data-total__inner-tags"
}
const _hoisted_37 = {
  key: 12,
  class: "task__files"
}
const _hoisted_38 = { class: "task__files-wrapper" }
const _hoisted_39 = { class: "task__file-name" }
const _hoisted_40 = { class: "task__file-ext" }
const _hoisted_41 = {
  key: 0,
  class: "data-total__inner-tags"
}
const _hoisted_42 = {
  key: 13,
  class: "task__date-create"
}
const _hoisted_43 = {
  key: 14,
  class: "task__type"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task__popover-title" }, "Тип", -1))
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "task__subtasks-total" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.3285 2.08093C4.17668 2.08093 3.22827 2.99421 3.22827 4.13869C3.22827 5.01777 3.78881 5.76115 4.56982 6.05794L4.90122 9.59189C4.97472 10.3757 5.55578 11.0161 6.32947 11.187L10.1787 12.0374C10.2692 13.099 11.1789 13.9209 12.2716 13.9209C13.4234 13.9209 14.3718 13.0076 14.3718 11.8632C14.3718 10.7187 13.4234 9.80542 12.2716 9.80542C11.4855 9.80542 10.7965 10.2294 10.4364 10.8617L6.59435 10.0129C6.32595 9.95363 6.13545 9.73511 6.1116 9.48071L5.79874 6.14452C6.72742 5.93596 7.42872 5.12268 7.42872 4.13869C7.42872 2.99421 6.48031 2.08093 5.3285 2.08093ZM4.37896 4.13869C4.37896 3.63965 4.79598 3.22061 5.3285 3.22061C5.86102 3.22061 6.27803 3.63965 6.27803 4.13869C6.27803 4.63772 5.86102 5.05676 5.3285 5.05676C4.79598 5.05676 4.37896 4.63772 4.37896 4.13869ZM11.322 11.8632C11.322 11.3641 11.739 10.9451 12.2716 10.9451C12.8041 10.9451 13.2211 11.3641 13.2211 11.8632C13.2211 12.3622 12.8041 12.7812 12.2716 12.7812C11.739 12.7812 11.322 12.3622 11.322 11.8632Z",
    fill: "white"
  })
], -1))
const _hoisted_48 = { class: "menu-item" }
const _hoisted_49 = { class: "menu-item" }
const _hoisted_50 = { class: "menu-item" }
const _hoisted_51 = { class: "menu-item" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task__negative" }, "Удалить тикет", -1))
const _hoisted_53 = {
  key: 0,
  class: "task-kanban-card__subtasks"
}

import { ComponentPublicInstance, PropType, computed, onMounted, ref, watch } from 'vue';
import { TaskAttachedFileModel, TaskModel, TaskTagModel } from '../models';
import { TaskViewSettings } from '../types';
import { TasksKanbanGrouppingTypeEnum, TaskViewElementEnum } from '../enums';
import {
  TirPmContextMenu,
  TirPmContextMenuButton,
  TirPmContextMenuMouseButtonEnum,
  TirPmIconView,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmPopover,
  TirPmTooltipElement,
} from 'tir-components';
import {
  ListBulletIcon,
  UserCircleIcon,
  TagIcon,
  EyeIcon,
  PaperClipIcon,
  ClockIcon,
  RectangleStackIcon,
  HashtagIcon,
  UserIcon,
  MapIcon,
  ShareIcon,
  TrashIcon,
  CurtainIcon,
  ClipboardDocumentIcon,
  CalendarDaysIcon,
  TimeSpentIcon,
} from 'tir-style-system/icons/outline';
import { ArrowTopRightOnSquareIcon, FlagIcon } from 'tir-style-system/icons/solid';
import { useResizeObserve } from '../composables';
import { getElementRect } from '../utils';
import { RouterLink, useRouter } from 'vue-router';
import { TaskParameter, TaskParameterModel, TaskParameterTypeEnum, WeeekTag } from '@/components';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import { copyToClipboard } from '../utils';
import { TaskImportServiceEnum } from '@/enums';
import PerformerListByOrder from './PerformerListByOrder.vue';
import { TaskKanbanAdapterService } from '../adapter';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from '../models/GetAccessCurrentUserInQueueTaskByIdResponseModel';


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskKanbanCard',
  props: {
  /**Данные задачи */
  task: {
    type: Object as PropType<TaskModel>,
    required: true,
  },
  /** Является ли задача вложенной */
  isSubtask: {
    type: Boolean,
    default: false,
  },
  /**Настройки отображения */
  viewSettings: {
    type: Object as PropType<TaskViewSettings>,
    default: (): TaskViewSettings => ({
      showNestedTasks: true,
      viewElements: Object.values(TaskViewElementEnum),
    }),
  },
  /**Группировка */
  grouppingType: {
    type: Number as PropType<TasksKanbanGrouppingTypeEnum>,
    required: true,
  },
  /**ID очереди */
  queueId: {
    type: String,
    required: true,
  },
  /**ID проекта */
  projectId: {
    type: Number,
    required: true,
  },
  /**Пользователья является админом проекта */
  isProjectAdmin: { type: Boolean },
  /**Доступы юзера к очереди */
  userAccess: { type: Object as PropType<GetAccessCurrentUserInQueueTaskByIdResponseModel> },
},
  emits: ["loadSubtasks", "openInDrawer", "toggle-submenu", "remove"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();
/**Адаптер */
const adapter = new TaskKanbanAdapterService();





/**Ссылка на элемент контейнера карточки */
const $cardContainer = ref<ComponentPublicInstance>();

/**Ссылка на компонент контекстного меню */
const $contextMenu = ref<InstanceType<typeof TirPmContextMenu>>();
/**Является ли юзер овнером */
const isOwner = CurrentUser.Roles.includes(UserRoleEnum.Owner);
/**Элемент сложности */
const difficultyElement = new TaskParameterModel({
  Id: props.task.Difficulty.DifficultyId,
  Color: props.task.Difficulty.DifficultyColor,
});

/**Ширина карточки */
const { width } = useResizeObserve($cardContainer, 10, 256);

/**Получить видимые элементы */
const getShowItems = <T>(
  items: Array<T>,
  getWidthItem: ((item: T) => number) | number,
  containerWidth: number,
) => {
  const showItems = new Array<T>();
  let currentWidth = 0;

  for (const item of items) {
    const itemWidth = typeof getWidthItem === 'function' ? getWidthItem(item) : getWidthItem;
    if (currentWidth + itemWidth <= containerWidth) {
      currentWidth += itemWidth;
      showItems.push(item);
    } else {
      break;
    }
  }
  return showItems;
};

/**
 * Функция для сортировки юзеров где текущий юзер отобржается первым
 *
 * @param users Список юзеров
 */

const sortUsersByCurrentUser = (users) => {
  return users.sort((a, b) => {
    if (a.Id == CurrentUser.Id) return -1;
    if (b.Id == CurrentUser.Id) return 1;
  });
};

/** Показанные исполнители */
const shownPerformers = computed(() => getShowItems(props.task.Performers, 23, width.value - 60));
let performersCurrentUserFerst;

const shownPerformersFerstCurrentUser = () => {
  performersCurrentUserFerst = sortUsersByCurrentUser(shownPerformers.value);
};

/** Показанные наблюдатели */
const shownObservers = computed(() => getShowItems(props.task.Observers, 23, width.value - 60));
let observersCurrentUserFerst;

const shownObserversFerstCurrentUser = () => {
  observersCurrentUserFerst = sortUsersByCurrentUser(shownObservers.value);
};
/**Доступ к добавлению задачи в очередность исполнителя */
const accessAddQueue = computed(() => props.userAccess.CanCustomizeOrder || isOwner);

/** Скрытые исполнители */
const hiddenPerformers = computed(
  () => props.task.Performers.length - shownPerformers.value.length,
);
/** Скрытые наблюдатели */
const hiddenObservers = computed(() => props.task.Observers.length - shownObservers.value.length);
/**Не передвигаемые группировки */
const nonDraggableGroups = computed<boolean>(() => {
  return (
    props.grouppingType === TasksKanbanGrouppingTypeEnum.Performer ||
    props.grouppingType === TasksKanbanGrouppingTypeEnum.Tag
  );
});

/**Получить ширину тега */
const getTagWidth = (tag: TaskTagModel) => {
  const template = `<div style="font-size: 0.875rem; padding: 0.125rem 0.5rem;">${tag.Name}</div>`;
  return Math.min(getElementRect(template)?.width ?? 0, 112) + 4;
};

/** Показанные тэги */
const shownTags = computed(() => {
  return getShowItems(props.task.Tags, getTagWidth, width.value - 60);
});
/** Скрытые тэги */
const hiddenTags = computed(() => props.task.Tags.length - shownTags.value.length);

/** Получить ширину тега-файла */
const getFileTagWidth = (file: TaskAttachedFileModel) => {
  const template = `<div style="padding: 0.125rem 0.5rem; font-size: 0.75rem; display: flex; align-items: center; column-gap: 0.25rem; width: fit-content; white-space: nowrap;"><span>${file.FileName}</span><span>${file.FileExtension}</span></div>`;
  return Math.min(getElementRect(template)?.width ?? 0, 154) + 4;
};

/** Показанные файлы */
const showFiles = computed(() =>
  getShowItems(props.task.AttachedFiles, getFileTagWidth, width.value - 60),
);

/** Скрытые файлы */
const hiddenFiles = computed(() => props.task.AttachedFiles.length - showFiles.value.length);

const formatNumber = (num: number) => {
  return num.toString().length === 2 ? num.toString() : `0${num}`;
};

const formatDate = (date: Date) => {
  return `${formatNumber(date.getDate())}.${formatNumber(
    date.getMonth() + 1,
  )}.${date.getFullYear()} в ${formatNumber(date.getHours())}:${formatNumber(date.getMinutes())}`;
};

/**Текст с датой создания */
const dateCreateText = computed(() => {
  if (props.task.DateCreate) {
    return `Создано ${formatDate(props.task.DateCreate)}`;
  }
});

/**Текст с датой дедлайна */
const deadlineDateText = computed(() => {
  if (props.task.Deadline) {
    return formatDate(props.task.Deadline);
  }
});
/**Маршрут деталки задачи */
const computedRoute = computed(() => {
  const route = router.resolve({
    name: 'task-detail',
    params: {
      projectId: props.projectId,
      queueId: props.queueId,
      taskId: props.task.Id,
    },
  });
  emit('toggle-submenu', props.queueId);
  return route;
});

const isView = computed(() => {
  const viewElements = props.viewSettings.viewElements;

  const settings = {
    Author: props.task.Author && viewElements.includes(TaskViewElementEnum.Author),
    Performers:
      shownPerformers.value.length && viewElements.includes(TaskViewElementEnum.Performers),
    Observers: shownObservers.value.length && viewElements.includes(TaskViewElementEnum.Observers),
    Priority: props.task.Priority && viewElements.includes(TaskViewElementEnum.Priority),
    Status:
      props.task.Status &&
      viewElements.includes(TaskViewElementEnum.Status) &&
      props.grouppingType !== TasksKanbanGrouppingTypeEnum.Status,
    Tags: shownTags.value.length && viewElements.includes(TaskViewElementEnum.Tags),
    Files: showFiles.value.length && viewElements.includes(TaskViewElementEnum.AttachedFiles),
    DateCreate: dateCreateText.value && viewElements.includes(TaskViewElementEnum.DateCreate),
    Type: props.task.Type?.Name && viewElements.includes(TaskViewElementEnum.Type),
    Deadline: deadlineDateText.value && viewElements.includes(TaskViewElementEnum.Deadline),
    EstimateTime: viewElements.includes(TaskViewElementEnum.EstimateTime),
    SpentTime: viewElements.includes(TaskViewElementEnum.WorkTime),
    Difficulty:
      props.task.Difficulty?.DifficultyId && viewElements.includes(TaskViewElementEnum.Difficulty),
    Queue: props.task?.Queues?.length && viewElements.includes(TaskViewElementEnum.Queue),
    MiddleBlock: false,
    FooterBlock: false,
  };

  settings.MiddleBlock =
    settings.Performers ||
    settings.Observers ||
    settings.Priority ||
    settings.Difficulty ||
    settings.Tags ||
    settings.Files;
  settings.FooterBlock = settings.DateCreate || settings.Type || settings.Deadline;

  return settings;
});

/**Открыти ли подзадачи */
const isOpenSubtasks = ref(false);

/**Открыть карту проекта */
const openSchema = computed(() => {
  return router.resolve({
    name: 'project-map',
    params: {
      taskId: props.task.Id,
      projectId: props.task.ProjectId,
    },
  });
});

/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'team-tasks',
      life: life ?? 2000,
      closable: true,
    }),
  );
};

/**Скопировать название и ссылку */
const copyNameAndLinkTask = async () => {
  const route = router.resolve({
    name: 'task-detail',
    params: {
      projectId: props.projectId,
      queueId: props.queueId,
      taskId: props.task.Id,
    },
  });
  if (!route?.href) return;

  const origin =
    window.location.hostname === 'localhost' ? 'https://beta.hub-pm.com' : window.location.origin;

  const link = origin + route.href;
  const textContent = `${props.task.Id} ${props.task.Name}`;

  if (await copyToClipboard(`[${textContent}](${link})`)) {
    $contextMenu.value.close();
    addNotification('Название и ссылка тикета скопирована');
    console.log(9);
  }
};
/**Форматирование времени */
const formatTime = (time: number) => {
  if (!time) return '-';
  const hours = Math.floor(time);
  const minutes = Math.round((time % 1) * 100); // 0.46 -> 46
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

/**Переключить видимость подзадач */
const toggelOpenSubtasks = () => {
  if (props.isSubtask || props.task.IsLoadingSubtasks) return;
  isOpenSubtasks.value = !isOpenSubtasks.value;
  if (props.task.Subtasks?.length) return;
  emit('loadSubtasks');
};

const openTaskInDrawer = (taskId: number) => {
  $contextMenu.value?.close();
  emit('openInDrawer', taskId);
};

watch(
  [() => props.task.Performers, () => props.task.Observers],
  () => {
    shownPerformersFerstCurrentUser();
    shownObserversFerstCurrentUser();
  },
  { immediate: true },
);
/**Открыть окно удаления задачи */
const openRemoveModal = (id: number, name: string) => {
  $contextMenu.value?.close();
  emit('remove', id, name);
};

return (_ctx: any,_cache: any) => {
  const _component_TaskKanbanCard = _resolveComponent("TaskKanbanCard", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmContextMenu), {
      ref_key: "$contextMenu",
      ref: $contextMenu,
      "min-width": "24.25rem",
      maxHeight: "max-content",
      "trigger-buttons": [_unref(TirPmContextMenuMouseButtonEnum).Right]
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(TirPmContextMenuButton), {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (openTaskInDrawer(__props.task.Id)))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_48, [
              _createVNode(_unref(CurtainIcon), { class: "menu-icon" }),
              _createTextVNode(" Открыть в шторке ")
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(RouterLink), {
          to: computedRoute.value,
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TirPmContextMenuButton), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "menu-icon" }),
                  _createTextVNode(" Открыть в новой вкладке ")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_unref(RouterLink), { to: openSchema.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(TirPmContextMenuButton), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_unref(MapIcon), { class: "menu-icon" }),
                  _createTextVNode(" Посмотреть карту проекта ")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_unref(TirPmContextMenuButton), {
          onClick: copyNameAndLinkTask,
          class: "task-card__menu-item"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ClipboardDocumentIcon), { class: "menu-icon" }),
            _createTextVNode(" Скопировать название и ссылку ")
          ]),
          _: 1
        }),
        (accessAddQueue.value)
          ? (_openBlock(), _createBlock(PerformerListByOrder, {
              key: 0,
              taskInfo: __props.task,
              onClosePopover: _cache[6] || (_cache[6] = ($event: any) => ($contextMenu.value.close()))
            }, null, 8, ["taskInfo"]))
          : _createCommentVNode("", true),
        (__props.isProjectAdmin || _unref(isOwner))
          ? (_openBlock(), _createBlock(_unref(TirPmContextMenuButton), {
              key: 1,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (openRemoveModal(__props.task.Id, __props.task.Name)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_unref(TrashIcon), { class: "menu-icon task__negative" }),
                  _hoisted_52
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(RouterLink), {
          class: _normalizeClass(["task", {
          'is-subtask': __props.isSubtask,
          task__pointer: nonDraggableGroups.value,
        }]),
          ref_key: "$cardContainer",
          ref: $cardContainer,
          to: computedRoute.value,
          onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["middle","prevent"])),
          onDragstart: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [
            (__props.isSubtask)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2))
              : _createCommentVNode("", true),
            (isView.value.Status)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: "task__status-bg",
                      style: _normalizeStyle({ backgroundColor: __props.task.Status.Color })
                    }, null, 4),
                    _hoisted_5,
                    _createElementVNode("span", _hoisted_6, _toDisplayString(__props.task.Status.Name), 1)
                  ]),
                  (__props.task.ImportService === _unref(TaskImportServiceEnum).Weeek)
                    ? (_openBlock(), _createBlock(_unref(WeeekTag), { key: 0 }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_unref(HashtagIcon), { class: "task-icon" }),
                _createTextVNode(" " + _toDisplayString(__props.task.Id), 1)
              ]),
              (!isView.value.Status && __props.task.ImportService === _unref(TaskImportServiceEnum).Weeek)
                ? (_openBlock(), _createBlock(_unref(WeeekTag), { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(__props.task?.Name), 1)
            ]),
            (isView.value.Queue)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_unref(TirPmTooltipElement), null, {
                    content: _withCtx(() => [
                      _hoisted_12
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(ListBulletIcon), { class: "task__sort-icon task-icon" })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(__props.task.Queues[0].Name), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.task.Author && __props.viewSettings.viewElements.includes(_unref(TaskViewElementEnum).Author))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_unref(TirPmTooltipElement), null, {
                    content: _withCtx(() => [
                      _hoisted_15
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(UserIcon), { class: "task__person-icon task-icon" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(TirPmTooltipElement), null, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(__props.task.Author.FirstName) + " " + _toDisplayString(__props.task.Author.MiddleName) + " " + _toDisplayString(__props.task.Author.LastName), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(TirPmIconView), {
                        title: ``,
                        size: 24,
                        isRounded: "",
                        colorCode: __props.task.Author.NoPhotoColor,
                        isBordered: false,
                        imageLoadUrl: __props.task.Author.ImageUrl
                      }, {
                        mainSlot: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.task.Author.FirstName[0] + __props.task.Author.LastName[0]), 1)
                        ]),
                        _: 1
                      }, 8, ["colorCode", "imageLoadUrl"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (isView.value.Performers)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_unref(TirPmTooltipElement), null, {
                    content: _withCtx(() => [
                      _hoisted_18
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(UserCircleIcon), { class: "task__person-icon task-icon" })
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(performersCurrentUserFerst), (person, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "task__persons",
                      key: idx
                    }, [
                      _createVNode(_unref(TirPmTooltipElement), null, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(person.FirstName) + " " + _toDisplayString(person.MiddleName) + " " + _toDisplayString(person.LastName), 1)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_unref(TirPmIconView), {
                            class: "task__person",
                            key: person.Id,
                            size: 24,
                            isRounded: "",
                            colorCode: person.NoPhotoColor,
                            isBordered: false,
                            imageLoadUrl: person.ImageUrl
                          }, {
                            mainSlot: _withCtx(() => [
                              _createTextVNode(_toDisplayString(person.FirstName[0] + person.LastName[0]), 1)
                            ]),
                            _: 2
                          }, 1032, ["colorCode", "imageLoadUrl"]))
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128)),
                  (hiddenPerformers.value > 0)
                    ? (_openBlock(), _createBlock(_unref(TirPmIconView), {
                        key: 0,
                        class: "task__person",
                        size: 24,
                        isRounded: "",
                        isBordered: false
                      }, {
                        mainSlot: _withCtx(() => [
                          _createTextVNode(" +" + _toDisplayString(hiddenPerformers.value), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (isView.value.Observers)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_unref(TirPmTooltipElement), null, {
                    content: _withCtx(() => [
                      _hoisted_21
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(EyeIcon), { class: "task__person-icon task-icon" })
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(observersCurrentUserFerst), (person) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_unref(TirPmTooltipElement), null, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(person.FirstName) + " " + _toDisplayString(person.MiddleName) + " " + _toDisplayString(person.LastName), 1)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_unref(TirPmIconView), {
                            class: "task__person",
                            key: person.Id,
                            size: 24,
                            isRounded: "",
                            colorCode: person.NoPhotoColor,
                            isBordered: false,
                            imageLoadUrl: person.ImageUrl
                          }, {
                            mainSlot: _withCtx(() => [
                              _createTextVNode(_toDisplayString(person.FirstName[0] + person.LastName[0]), 1)
                            ]),
                            _: 2
                          }, 1032, ["colorCode", "imageLoadUrl"]))
                        ]),
                        _: 2
                      }, 1024),
                      (hiddenObservers.value > 0)
                        ? (_openBlock(), _createBlock(_unref(TirPmIconView), {
                            key: 0,
                            class: "task__person",
                            size: 24,
                            isRounded: "",
                            isBordered: false
                          }, {
                            mainSlot: _withCtx(() => [
                              _createTextVNode(" +" + _toDisplayString(hiddenObservers.value), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  }), 256))
                ]))
              : _createCommentVNode("", true),
            (isView.value.Priority)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_unref(TirPmTooltipElement), null, {
                    content: _withCtx(() => [
                      _hoisted_25
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(FlagIcon), {
                        class: "task-icon",
                        style: _normalizeStyle({ color: __props.task.Priority.Color })
                      }, null, 8, ["style"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(__props.task.Priority.Name || '-'), 1)
                ]))
              : _createCommentVNode("", true),
            (isView.value.Difficulty)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createVNode(_unref(TaskParameter), {
                    preview: "",
                    data: _unref(difficultyElement),
                    type: _unref(TaskParameterTypeEnum).Difficulty
                  }, null, 8, ["data", "type"]),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(__props.task.Difficulty.DifficultyName || '-'), 1)
                ]))
              : _createCommentVNode("", true),
            (isView.value.Deadline)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createVNode(_unref(TirPmTooltipElement), null, {
                    content: _withCtx(() => [
                      _hoisted_30
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(CalendarDaysIcon), { class: "task-icon" })
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(deadlineDateText.value), 1)
                ]))
              : _createCommentVNode("", true),
            (isView.value.EstimateTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createVNode(_unref(TirPmTooltipElement), null, {
                    content: _withCtx(() => [
                      _createTextVNode("Оценка времени")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(ClockIcon), { class: "task-icon" })
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(formatTime(__props.task.EstimateTime)), 1)
                ]))
              : _createCommentVNode("", true),
            (isView.value.SpentTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createVNode(_unref(TirPmTooltipElement), null, {
                    content: _withCtx(() => [
                      _createTextVNode("Затраченное время")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(TimeSpentIcon), { class: "task-icon" })
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(formatTime(__props.task.WorkTime)), 1)
                ]))
              : _createCommentVNode("", true),
            (isView.value.Tags)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createVNode(_unref(TirPmTooltipElement), null, {
                    content: _withCtx(() => [
                      _hoisted_34
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(TagIcon), { class: "task__tag-icon task-icon" })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shownTags.value, (tag) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "task__tag",
                        style: _normalizeStyle({ borderColor: tag.Color }),
                        key: tag.Id
                      }, [
                        _createElementVNode("div", {
                          class: "task__tag-bg",
                          style: _normalizeStyle({ backgroundColor: tag.Color })
                        }, null, 4),
                        _createElementVNode("span", {
                          class: "task__tag-text",
                          style: _normalizeStyle({ color: tag.Color })
                        }, _toDisplayString(tag.Name), 5)
                      ], 4))
                    }), 128))
                  ]),
                  (hiddenTags.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, "+" + _toDisplayString(hiddenTags.value), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (isView.value.Files)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createVNode(_unref(PaperClipIcon), { class: "task-icon" }),
                  _createElementVNode("div", _hoisted_38, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showFiles.value, (file) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "task__file",
                        key: file.Id
                      }, [
                        _createElementVNode("span", _hoisted_39, _toDisplayString(file.FileName), 1),
                        _createElementVNode("span", _hoisted_40, _toDisplayString(file.FileExtension), 1)
                      ]))
                    }), 128))
                  ]),
                  (hiddenFiles.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, "+" + _toDisplayString(hiddenFiles.value), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (isView.value.DateCreate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(dateCreateText.value), 1))
              : _createCommentVNode("", true),
            (isView.value.Type)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createVNode(_unref(TirPmTooltipElement), null, {
                    content: _withCtx(() => [
                      _hoisted_44
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(RectangleStackIcon), { class: "task-icon" })
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(__props.task.Type.Name), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.task.SubtasksCount && __props.viewSettings.showNestedTasks)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 15,
                  class: _normalizeClass(['task__subtasks-total-info', { 'is-subtask': __props.isSubtask }]),
                  onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                  onMouseup: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                  onTouchstart: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                  onClick: _withModifiers(toggelOpenSubtasks, ["stop","prevent"])
                }, [
                  _createElementVNode("div", _hoisted_46, "Вложенных задач: " + _toDisplayString(__props.task.SubtasksCount), 1),
                  _hoisted_47
                ], 42, _hoisted_45))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class", "to"])
      ]),
      _: 1
    }, 8, ["trigger-buttons"]),
    (__props.task.Subtasks?.length && __props.viewSettings.showNestedTasks && isOpenSubtasks.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.task.Subtasks, (subtask, idx) => {
            return (_openBlock(), _createBlock(_component_TaskKanbanCard, {
              key: idx,
              task: subtask,
              "is-subtask": "",
              "view-settings": __props.viewSettings,
              "groupping-type": __props.grouppingType,
              "project-id": __props.projectId,
              "queue-id": __props.queueId,
              isProjectAdmin: __props.isProjectAdmin,
              onOpenInDrawer: _cache[8] || (_cache[8] = ($event: any) => (emit('openInDrawer', $event))),
              onRemove: openRemoveModal
            }, null, 8, ["task", "view-settings", "groupping-type", "project-id", "queue-id", "isProjectAdmin"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})